var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper--site"},[_c('MainHeader'),_c('v-mobile-header',{on:{"mobileActive":_vm.mobileActive}}),_c('router-view'),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }